import * as React from 'react';

import {CheckboxButton} from 'shells/checkbox/checkbox-button';
import {CheckboxGroup} from 'shells/checkbox/checkbox-group';
import {FormField} from 'shells/form/form-field';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {getReduxFormError} from './helpers';

import styles from './fields.module.css';

type BaseProps = {
    title: string;
    options: {
        value: string;
        title: string;
    }[];
    isTwoColumns?: boolean;
};

type ReduxFormProps = BaseProps &
    FieldProps & {
        variant: 'redux-form';
    };

type ControlledProps = BaseProps & {
    variant: 'controlled';
    name: string;
    value: string[];
    onChange: (value: string[]) => void;
    error?: string | null | undefined;
};

type Props = ReduxFormProps | ControlledProps;

export function TinyIntroCheckboxButtons(props: Props) {
    const name = props.variant === 'redux-form' ? props.input.name : props.name;
    const value = props.variant === 'redux-form' ? props.input.value : props.value;
    const onChange = props.variant === 'redux-form' ? props.input.onChange : props.onChange;
    const error = props.variant === 'redux-form' ? getReduxFormError(props.meta) : props.error;

    return (
        <FormField innerId={name} label={props.title} errorMessage={error}>
            <CheckboxGroup name={name} selectedValues={value || []} onChange={onChange}>
                <div
                    className={
                        props.isTwoColumns
                            ? styles['input-container--two-columns']
                            : styles['input-container']
                    }
                >
                    {/* @ts-expect-error */}
                    {props.options.map((option) => {
                        return (
                            <CheckboxButton key={option.value} value={option.value} isLarge={true}>
                                {option.title}
                            </CheckboxButton>
                        );
                    })}
                </div>
            </CheckboxGroup>
        </FormField>
    );
}
